import { AxiosError } from 'axios'
import * as log from '@/model/util/log/Logger'

/**
 * レスポンス種別がblobであるか判定する
 * @param responseType レスポンス種別
 * @returns true: blob, false:blobでない
 */
const isBlob = (responseType: string): boolean => responseType === 'blob'

/**
 * blobデータの場合はBlobからオブジェクトに変換する
 * @param error エラー情報
 * @returns JSONオブジェクト(blobの場合は変換、それ以外の場合はデータをそのまま返す) or undefined(json変換失敗の場合)
 */
const convertBlob = async (error: AxiosError) => {
  if (isBlob(error.request.responseType)) {
    // blobの場合はblobを文字列に変換してjson変換する
    const blobdata = error.response?.data as Blob
    const data = await blobdata.text().then((text) => {
      try {
        const res = JSON.parse(text)
        return res
      } catch (e) {
        // エラーの場合はundefinedを返す
        log.debug(`Response data is not json. data:${text}}`)
        return undefined
      }
    })
    return data
  }

  return error.response?.data
}

export { isBlob, convertBlob }
